import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import MeetingModalityService from "../../src/Services/MeetingModality.service";
const MeetingModalityLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type 'string[]'.
        defaultIds: props.defaultIds,
        labelKey: "name",
        // @ts-expect-error - TS2322 - Type '(ids: number[]) => Promise<MeetingModality[]>' is not assignable to type '(ids: string[]) => Promise<MeetingModality[]>'.
        fetchItemsById: (ids) => {
            return MeetingModalityService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return MeetingModalityService.searchAll(search);
        },
        optionRenderer: function optionRenderer(meetingModality) {
            return _jsx("span", { children: meetingModality.name });
        },
    });
};
export default MeetingModalityLookup;
